import { render, staticRenderFns } from "./riesgosModificableShow.vue?vue&type=template&id=0b90fb25&scoped=true&"
import script from "./riesgosModificableShow.vue?vue&type=script&lang=js&"
export * from "./riesgosModificableShow.vue?vue&type=script&lang=js&"
import style0 from "./riesgosModificableShow.vue?vue&type=style&index=0&id=0b90fb25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90fb25",
  null
  
)

export default component.exports